import { ComponentChild } from 'preact';
import CircleInfoIcon from 'images/icons/CircleInfo.svg';

import { Icon } from 'components/Icon';

import { useTip } from './utilities';

import styles from './Tip.module.scss';

interface TipProps {
  content: ComponentChild;
}

export function Tip({ content }: TipProps) {
  const {
    open,
    reference,
    floating,
    referenceProps,
    floatingProps,
    floatingStyle,
  } = useTip();

  return (
    <>
      <div ref={reference} {...referenceProps} className={styles.Tip}>
        <Icon source={CircleInfoIcon} />
      </div>
      {open && (
        <div
          ref={floating}
          style={floatingStyle}
          className={styles.Content}
          role="tooltip"
          {...floatingProps}
        >
          {content}
        </div>
      )}
    </>
  );
}
